import { render, staticRenderFns } from "./nextPlayBoxMapping.vue?vue&type=template&id=fa4adab6&"
import script from "./nextPlayBoxMapping.vue?vue&type=script&lang=js&"
export * from "./nextPlayBoxMapping.vue?vue&type=script&lang=js&"
import style0 from "./nextPlayBoxMapping.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports